<template>
  <div style="display: flex; position: relative; width: 100%; height: 100%">

    <div style="flex-grow: 1; display: flex; justify-content: center" class="pa-4">

			<CargaInicial v-if="$root.sitios.cargando"></CargaInicial>

			<v-sheet v-else-if="sitio" id="sitio">
				<encabezado v-model="sitio.datos.encabezado"></encabezado>
				<sitio-seccion
					v-for="(s, i) in sitio.datos.página_principal.secciones"
					:key="`cnsttr-dts-sccn-${i}${$root.aleatorio()}`"
					v-model="sitio.datos.página_principal.secciones[i]"
					:cantidadDeSecciones="sitio.datos.página_principal.secciones.length"
					:posición="i"
					@eliminar="eliminarSección(i)"
					@subir="subirSección(i)"
					@bajar="bajarSección(i)"
				>
				</sitio-seccion>
				<!--<div>
					pie de pagina aquí...
				</div>-->
			</v-sheet>

			<v-row v-else>
				<v-col cols="12" sm="6" md="4" lg="2" offset-lg="5" offset-md="4" offset-sm="3">
					<v-alert type="error" :icon="false" class="text-center">
						<v-icon>mdi-alert</v-icon> [4393] Ocurrió un error.
					</v-alert>
				</v-col>
			</v-row>
		</div>

		<v-navigation-drawer
      permanent
			right
			:width="256"
			style="flex-grow: 0; flex-shrink: 0; flex-basis: 256px;"
    >

			<v-card class="text-center">
				<v-btn color="indigo" class="ma-2" tile :dark="!guardando" @click="guardar" :loading="guardando" :disabled="guardando">Guardar</v-btn>
				<v-btn color="pink" tile dark @click="preparandoPublicación = true">Publicar</v-btn>
			</v-card>

			<v-list three-line>
				<template v-for="(sección, i) in secciones">

					<v-list-item
						vvvv-else
						:key="`cnsttr-sccns-${i}`"
						@click="agregarSección(sección.definición)"
						style="min-height: unset"
						:class="{ 'pa-2': !sección.título }"
					>
						<!--<v-list-item-avatar>
							<v-img :src="sección.avatar"></v-img>
						</v-list-item-avatar>-->
						
						<v-list-item-icon v-if="sección.ícono">
							<v-icon>{{ sección.ícono }}</v-icon>
						</v-list-item-icon>
						<div v-else v-html="sección.imagenSVG" style="border: 1px solid #eee;"></div>

						<v-list-item-content class="py-0 pl-2">
							<v-list-item-title v-if="sección.título" v-html="sección.título"></v-list-item-title>
							<v-list-item-subtitle v-else v-html="sección.descripción" style="line-clamp: 3;"></v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-divider :key="i"></v-divider>

				</template>

				<!--<v-list-item>
					<subir-archivo></subir-archivo>
				</v-list-item>-->
			</v-list>

    </v-navigation-drawer>

		<v-dialog
      v-model="preparandoPublicación"
      max-width="800"
    >
      <v-card>
				<v-card-title>Publicar el sitio</v-card-title>
				<v-card-text>
					<p>Elije el dominio con el cuhal publicar el sitio</p>
					<v-select
						v-model="dominio"
						:items="$root.dominios"
						label="Dominio"
						item-text="identificador"
						item-value="identificador"
						append-icon="mdi-menu-down"
						required
					></v-select>
				</v-card-text>
				<v-card-actions>
					<v-btn text color="deep-purple accent-4" @click="publicar">Publicar</v-btn>
					<v-btn text @click="preparandoPublicación = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

  </div>
</template>

<script>

// ================ PROBABLEMENTE ESTE COMPONENTE NO SE USARÁ, SINO dominio_contrsuctor.vista ============

import { SeccionesPreestablecidas } from '@/components/constructor/secciones'
import CargaInicial from '@/views/CargaInicial'
import Encabezado from '@/components/constructor/Sitio/Encabezado'
import Seccion from '@/components/constructor/Sitio/Pagina/Seccion/Seccion'

export default {
  name: 'sitio-constructor-vista',

  components: {
		CargaInicial,
		'sitio-seccion': Seccion,
		Encabezado
  },

  data: () => ({
		guardando: false,

		preparandoPublicación: false,
		publicando: false,
		dominio: null,

		sitio: null,

		secciones: SeccionesPreestablecidas
	}),

	watch: {
		'$root.sitios.cargando': function(val) {
			if (val) {
				return
			}

			console.log('tttttttttttttt', this.$root.obtenerSitio(this.$route.params.sitio))
			this.sitio = this.$root.obtenerSitio(this.$route.params.sitio)
		}
	},

	beforeMount: function() {
		this.sitio = this.$root.obtenerSitio(this.$route.params.sitio)
		// ------------------ pendiente revisar cómo empezar uno nuevo en caso de que no exista... --- esto sería condicionado a la URL, solo aplicaría para dominios??? no, creo ue no... mejopr se inicializa al momento de crearlo en el modal antes, para no condicionar aquí... ---------
	},

	mounted: function() {
		console.log('mmmmmm', this.sitio)
		//if (!this.value) {
		//	this.$emit('input', this.objetoSitioPredeterminado())
		//}
	},

	
	methods: {
		guardar: function() {
			let doc = null
			let col = this.$root.firestore.collection('cuentas').doc(this.$root.cuenta.identificador).collection('sitios')
			if (this.sitio.identificador) {
				doc = col.doc(this.sitio.identificador).set(this.sitio.datos)
			} else {
				doc = col.add(this.sitio.datos)
			}

			let esNuevo = !this.sitio.identificador

			this.guardando = true
			doc.then( docRef => {
				//this.$emit('input', this.sitio)
				this.$root.correcto('Guardado.')
				this.guardando = false
				if (esNuevo) {
					this.sitio.identificador = docRef.id
					console.log('push después de crear nuevo...')
					this.$router.push({ path: `/sitios/${this.sitio.identificador}` })
				}
			}).catch( error => {
				console.error(error)
				this.$root.error('Ocurrió un error al guardar. Aegúrese de que no le falte contenido al sitio.')
				this.guardando = false
			})
		},
		publicar: function() {
			if (!this.dominio) {
				this.$root.error('Debes seleccionar el dominio')
				return
			}

			console.log('dddddd ['+this.dominio+']')

			this.$root.axios.post('/sitios', Object.assign({ dominio: this.dominio }, this.sitio.datos)).then( response => {
				console.log(response)
			}).catch( error => {
				console.log(error)
				this.$root.error('Ocurrió un error')
			})
		},
		agregarSección(d) {
			this.sitio.datos.página_principal.secciones.push(d)
		},
		eliminarSección: function(i) {
			this.$delete(this.sitio.datos.página_principal.secciones, i)
		},
		subirSección: function(i) {
			let sccn = this.sitio.datos.página_principal.secciones[i]
			this.sitio.datos.página_principal.secciones.splice(i, 1)
			this.sitio.datos.página_principal.secciones.splice(i-1, 0, sccn)
		},
		bajarSección: function(i) {
			let sccn = this.sitio.datos.página_principal.secciones[i]
			this.sitio.datos.página_principal.secciones.splice(i, 1)
			this.sitio.datos.página_principal.secciones.splice(i+1, 0, sccn)
		},
		/*objetoSitioPredeterminado: function() {
			return {
				identificador: '',
				datos: {
					encabezado: {
						texto: '<h1>Mi sitio web</h1>',
						estilos: {
							'margin-bottom': '50px',
							'height': '300px',
							//'background-image': "url('https://i.ytimg.com/an_webp/Yrv5VlMJPfI/mqdefault_6s_480x270.webp?du=3000&sqp=CLywrPgF&rs=AOn4CLCUOmoQ2lSvXpIoYVRAUeRJMJmjkA')",
						}
					},
					página_principal: {
						secciones: []
					},
					otras_páginas: []
				}
			}
		}*/
		//
	}
};

</script>

<style scoped>
#sitio {
	height: 100%;
	min-width: 1000px; /* Esto no debería ir en el sitio final... revisar... */
	max-width: 1500px;
	border-left: 1px solid silver;
	border-right: 1px solid silver;
	box-shadow: 0 0 4px 4px #bbb;
}
</style>